import React, { useState } from "react"
import moment from "moment"
import { Modal, Button, Input, Dropdown, Menu } from "antd"
import { toast } from "react-toastify"
import { axiosInstance } from "../Config"
import secureLocalStorage from "react-secure-storage"
import Loader from "../Loader"

const getMaxSlotDate = (slotsString) => {
  let slots = slotsString || [];

  // Only parse if it's a string
  if (typeof slotsString === 'string') {
    try {
      slots = JSON.parse(slotsString); // Parse stringified array
    } catch (e) {
      console.error("Error parsing JSON: ", e);
      return null; // Return null or handle the error accordingly
    }
  }

  // Find the maximum date from the slots array
  const maxSlotDate = slots.reduce((max, slot) => {
    const slotDate = moment(slot.date, "DD-MM-YYYY"); // Convert string to moment date
    return slotDate.isAfter(max) ? slotDate : max; // Return the latest date
  }, moment("1970-01-01")); // Start with a very old date

  return maxSlotDate;
}


const LessonsTable = ({ data, setSlotsModal, lessonData, setLessonData, handleStatus, setcurrentlesson, fetchdata, actions = true }) => {
  const [open, setOpen] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [rejectReason, setRejectReason] = useState('')
  const [currentLessonId, setCurrentLessonId] = useState(null)
  const [Loading, setLoading] = useState(false);
  const users = secureLocalStorage.getItem("credentials");

  function getSessionType(lesson_type) {
    switch (lesson_type) {
      case 'Manual': return (<div className="ribbon ribbon-top-left bg-light-green"><span>{lesson_type}</span></div>)
      case 'Automatic': return (<div className="ribbon ribbon-top-left bg-light-blue2"><span>{lesson_type}</span></div>)
    }
  }

  // Handle status change and open modal for Reject option
  const handleSelectChange = (e, lessonId) => {
    const value = e.target.value;
    if (value === '1') { // 'Reject' is selected
      setCurrentLessonId(lessonId) // Store the current lesson ID
      setModalVisible(true); // Show modal
    } else {
      handleReject(lessonId, value); // Handle Accept or Pending normally
    }
  };

  // Handle rejection reason submission
  const handleRejectSubmit = (e) => {
    e.preventDefault();
    if (rejectReason.trim()) {
      // Call a function to handle rejection with reason, passing the lessonId and reason
      handleReject(currentLessonId, 1, rejectReason);
      setModalVisible(false); // Close the modal
      setRejectReason(''); // Clear the reason
    } else {
      // Optionally show an error if reason is empty
      alert('Please enter a reason for rejection');
    }
  }

  const handleReject = async (lessonID, value, reason) => {
    try {
      setLoading(true);
      const formdata = new FormData();

      if (Number(value) === 0) {
        formdata.append("lessonid", lessonID);
        formdata.append("accept", value);
      } else {
        formdata.append("reason", reason)
        formdata.append("lessonid", lessonID);
        formdata.append("accept", value);
      }

      const response = await axiosInstance.post(`instruc-accept`, formdata, {
        headers: {
          Authorization: `Bearer ${users.token}`
        }
      })

      if (response?.data?.success === true) {
        toast.success(`Lesson ${value === 1 ? "Rejected" : "Accepted"}`)
        setLoading(false);
        setTimeout(() => {
          fetchdata();
        }, 1000);
        return;
      }

      if (response?.data?.success === false) {
        toast.error("Something Went Wrong");
        setLoading(false);
      }

    } catch (e) {
      console.log("Error", e.target.value);
      setLoading(false);
    }

  }

  return (
    <>
      {Loading && <Loader />}
      <div className='table-responsive'>
        <table className="jean-table table">
          <tbody>
            {data?.map((lesson, i) => {
              return (
                <tr key={lesson.id} className="" >
                  <td className=" box">
                    <div className="therapist-info ">
                      {getSessionType(lesson.cartype)}
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info ps-2">
                      <h4 className="mb-1 fs-5">Student Name</h4>
                      <p className="mb-0">
                        {lesson?.user?.name ? lesson?.user?.name : "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info col-10">
                      <h4 className="mb-1 fs-5">Course Name</h4>
                      <p className="mb-0 text-truncate">
                        {lesson?.cources?.title ? lesson?.cources?.title : "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info">
                      <h4 className="mb-1 fs-5">Start Date </h4>
                      <p className="mb-0">
                        {(lesson?.bookingdate)
                          ?
                          moment(lesson?.bookingdate).format("DD MMM, YYYY")
                          : "--"}
                      </p>
                    </div>
                  </td>

                  <td>
                    <div className="therapist-info">
                      <h4 className="mb-1 fs-5">Status</h4>
                      <p className={`mb-0 text-capitalize text-${lesson.status === 0 ? 'danger' : lesson.status === 1 ? 'warning' : 'success'} fw-semibold`}>
                        {lesson.status === 0 ? 'Pending' : lesson.status === 1 ? 'In Progress' : 'Completed'}
                      </p>
                    </div>
                  </td>

                  <td className="pe-4">
                    <div className=' text-center'>
                      {
                        (lesson.status === 0) ?
                          <div className='me-3'>
                            <select className={`btn btn-light text-dark fs-5`}
                              onChange={(e) => handleSelectChange(e, lesson.id)}
                              value={lesson.instacceptance}>
                              <option value={null}>Acceptance</option>
                              <option value={0}>Accept</option>
                              <option value={1}>Reject</option>
                            </select>
                          </div> : <span className="text-success fw-bold">Accepted</span>
                      }
                    </div>
                  </td>
                  {
                    actions ?
                      <td>
                        <Dropdown style={{ width: '250px' }} overlay={
                          <Menu className="p-1">
                            <Menu.Item key={1}>
                              {
                                <button
                                  onClick={() => {
                                    setOpen(true)
                                    setLessonData(lesson)
                                  }}
                                  className="dropdown-item"
                                  title="View Details"
                                >
                                  <i className="bi bi-eye me-2"></i> View
                                </button>
                                // <Link className="dropdown-item" to={`${config.appUrl}edit-course/${course.id}`}>
                                //     <i className="icon-eye mr-10 text-green"></i>
                                //     View
                                // </Link>
                              }
                            </Menu.Item>
                            <Menu.Item key={2}>
                              {
                                <button className="dropdown-item"
                                  onClick={() => {
                                    setSlotsModal(true)
                                    setcurrentlesson(lesson)
                                  }}
                                >
                                  <i className="icon-timer2 mr-10 text-black"></i>
                                  Slots
                                </button>
                              }
                            </Menu.Item>
                          </Menu>
                        } className="">
                          <a
                            onClick={(e) => e.preventDefault()}
                            className="ps-dropdown__toggle">
                            <i className="icon-ellipsis"></i>
                          </a>
                        </Dropdown>
                      </td> : null
                  }
                </tr>
              )
            })}

            {data?.length === 0 && (
              <tr>
                <td colSpan="5" className="alert alert-success ps-4">No Lesson Found !!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Reject reason modal */}
      <Modal
        open={modalVisible}
        title="Reason for Rejection"
        centered
        onCancel={() => setModalVisible(false)}
        width={700}
        bodyStyle={{ padding: '0' }}
        footer={null}
      >
        <div className="bg-gradientt p-4 pb-5">
          <form onSubmit={handleRejectSubmit}>
            <div className='row'>
              <div className="col-12 px-4">
                <div >
                  <div className="input-field ">
                    <label htmlFor="screenshot" className='label'>
                      <input type="text" id="screenshot"
                        required
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        placeholder="Reason for Rejection" className='pb-2 ' />
                      <span>Reason for Rejection  <i className='text-danger'>*</i></span>
                    </label>
                  </div>
                </div>
              </div>

              <div className='col-md-12 ps-4 mt-4'>
                <button type="submit" className="button btn-green color-white" >
                  Submit</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* View Details Modal */}
      <Modal
        open={open}
        title="Lesson Details"
        centered
        onCancel={() => setOpen(false)}
        width={700}
        bodyStyle={{ padding: '0' }}
        footer={null}
      >
        <div className="bg-gradientt p-4">
          <div className='p-2 pb-0'>
            <table className='table table-bordered' style={{ verticalAlign: 'middle' }}>
              <tbody>
                {/* <tr>
                  <th className='col-4 text-green p-3'>Provisional Licence?</th>
                  <td className='p-3'>Yes</td>
                </tr> */}

                <tr>
                  <th className='col-4 text-green p-3'>Car Type</th>
                  <td className='p-3'>{lessonData?.cartype || "--"}</td>
                </tr>

                <tr>
                  <th className='col-4 text-green p-3'>Student Name</th>
                  <td className='p-3'>{lessonData?.user?.name || "--"}</td>
                </tr>

                <tr>
                  <th className='col-4 text-green p-3'>Student Contact</th>
                  <td className='p-3'>{lessonData?.user?.mobile || "--"}</td>
                </tr>

                <tr>
                  <th className='col-4 text-green p-3'>Student Email</th>
                  <td className='p-3'>{lessonData?.user?.email || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Course Name</th>
                  <td className='p-3'>{lessonData?.cources?.title || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Slot Time</th>
                  <td className='p-3'>{lessonData?.bookingtime || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Start Date</th>
                  <td className='p-3'>{moment(lessonData?.bookingdate).format("DD MMM , YYYY") || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>End Date</th>
                  <td className='p-3'>{moment(getMaxSlotDate(lessonData?.slots)).format("DD MMM , YYYY") || "--"}</td>
                </tr>
                <tr>
                  <th className='col-4 text-green p-3'>Amount (£)</th>
                  <td className='p-3'>£ {lessonData?.updated_price || "--"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default LessonsTable
